export const fontFamily = 'Vazir FD, sans-serif';
